/**
 * BaluarteLogo — renders the firm's licensed logo from src/assets/.
 *
 * Three variants mirror the source files:
 *   - 'horizontal'  → header / login (default; Logo Baliuarte BWA wordmark)
 *   - 'stacked'     → tall layouts; uses LOGO-BALUARTE-VERTICAL-UK
 *   - 'medallion'   → favicon, dashboard accent; uses ROSETA
 */
import horizontalUrl from '../assets/baluarte-horizontal.png';
import verticalUrl   from '../assets/baluarte-vertical.png';
import medallionUrl  from '../assets/baluarte-roseta.png';

export interface BaluarteLogoProps {
  variant?: 'horizontal' | 'stacked' | 'medallion';
  height?: number;
}

export function BaluarteLogo({
  variant = 'horizontal',
  height = 28,
}: BaluarteLogoProps) {
  const src =
    variant === 'medallion' ? medallionUrl :
    variant === 'stacked'   ? verticalUrl  :
    horizontalUrl;
  // Fixed height; width auto-scales to preserve aspect ratio of the source asset.
  return (
    <img
      src={src}
      alt="Baluarte"
      style={{ height, width: 'auto', display: 'block' }}
    />
  );
}
